import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "user-commute"
};
const _hoisted_2 = {
  class: "main-wrap user-commute-wrap"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "通勤设置", -1);
const _hoisted_4 = {
  class: "card setting-card"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_cell = _resolveComponent("van-cell");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_nav_bar, {
    title: $setup.title
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_cell, {
    title: "住宅地址",
    label: "设置你的住宅位置上下车点",
    "is-link": "",
    onClick: _cache[0] || (_cache[0] = $event => $options.goAddressMapSelect('home'))
  }, {
    value: _withCtx(() => [_createTextVNode(_toDisplayString($setup.setting && $setup.setting.homeAddress ? "已设置" : "未设置"), 1)]),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "公司地址",
    label: "设置你的公司上下车点位置",
    "is-link": "",
    onClick: _cache[1] || (_cache[1] = $event => $options.goAddressMapSelect('work'))
  }, {
    value: _withCtx(() => [_createTextVNode(_toDisplayString($setup.setting && $setup.setting.workAddress ? "已设置" : "未设置"), 1)]),
    _: 1
  })])])]);
}